import { render, staticRenderFns } from "./range-field.vue?vue&type=template&id=c1ba0378"
import script from "./range-field.vue?vue&type=script&lang=js"
export * from "./range-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports